import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { OperatorLimitProfile } from "src/_models";
import { LimitExtrasLabel, LimitStakesLabel } from "src/_helpers/utils";

@Component({
  selector: "app-assign-user-limit",
  templateUrl: "./assign-user-limit.component.html",
  styleUrls: ["./assign-user-limit.component.scss"],
})
export class AssignUserLimitComponent implements OnInit {
  limits: OperatorLimitProfile[] = [];
  selectedLimitId: string = "";
  loading: boolean = true;

  constructor(
    private appService: AppService,
    public router: Router,
    public dialogRef: MatDialogRef<AssignUserLimitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.selectedLimitId = this.data.limitId || "";
    this.appService
      .getOperatorLimits({ OperatorId: this.data.operatorId })
      .subscribe((res) => {
        this.loading = false;
        if (res.status === "RS_OK") {
          this.limits = res.limits || [];
        } else {
          this.appService.openErrorBar(res.errorDescription);
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
  }

  get selectedLimitConfig() {
    const found = this.limits.find((l) => l.name === this.selectedLimitId);
    return found ? found.config : null;
  }

  // One tile per section of the profile, so the preview says what the punter
  // will actually get - including the sections that are deliberately left at 0
  // and therefore fall through to the operator's own limits.
  get previewRows() {
    const config = this.selectedLimitConfig;
    if (!config) {
      return [];
    }
    return [
      this.describeSection("Match odds", config.matchOdds),
      this.describeSection("Premium", config.premium),
      this.describeSection("Bookmaker", config.bookmaker),
      this.describeSection("Fancy", config.fancy),
    ];
  }

  describeSection(label: string, section: any) {
    return {
      label: label,
      value: LimitStakesLabel(section),
      extra: LimitExtrasLabel(section),
    };
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    this.appService
      .assignUserLimit(this.data.userId, this.data.operatorId, this.selectedLimitId)
      .subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(
            this.selectedLimitId ? "Limit has been assigned." : "Limit assignment cleared."
          );
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
  }
}
